<template>
  <v-app
    :class="
      `${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`
    "
  >
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.btn-gallo {
  background: #fed03d;
  color: #333333;
  border-color: #fed03d;
}

.btn-gallo-success {
  background: #009045;
  color: #fff;
  border-color: #009045;
}

.btn-gallo-success:hover {
  background: #00aa52;
  color: #fff;
  border-color: #00aa52;
}

.btn-gallo:hover {
  background: #333333;
  color: #ffffff;
  border-color: #ffffff;
}
.text-primary-gallo {
  color: #fed03d;
}

/* set bad styles on aplication */
.v-application ul,
.v-application ol {
  padding-left: 0;
}
.v-application .primary {
  background-color: #009045 !important;
  border-color: #009045 !important;
}
.v-application a {
  color: #009045;
  font-size: larger;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #009045;
}

.table > thead {
  background-color: #009045;
  color: #fff;
}
/* .v-application .purple--text */
.v-application .gallo--text {
  color: #009045 !important;
  caret-color: #009045 !important;
}

.v-application .primary {
  background-color: #009045 !important;
  border-color: #009045 !important;
}
.v-application a {
  color: #009045;
  font-size: larger;
}
.nav-link:hover,
.nav-link:focus {
  color: #000000de;
}
</style>
